import DataQuery, { SortOrder } from '../../../../common/scripts/Toolkit/Helper/DataQuery';
import DataType from '../../../../tableEngine/Script/Game/Data/Config/DataStructure';
import IHistoryData from '../../../../tableEngine/Script/Game/Data/DataObject/History/IHistoryData';
import HistoryModel from '../../../../tableEngine/Script/Game/Data/Model/HistoryModel';
import HistoryData from '../DataObject/History/HistoryData';
import ILobbyHistoryService from '../Service/ILobbyHistoryService';

export const JACKPOT_QUERY_TYPE = 0;

enum EventType {
    GAME_TYPE_CHANGED = 'GAME_TYPE_CHANGED',
}

export default class LobbyHistoryModel extends HistoryModel {
    public static readonly EVENT_TYPE = { ...HistoryModel.EVENT_TYPE, ...EventType };
    protected _jackpotQuery: DataQuery<IHistoryData> = null;
    private _currentRecordType: DataType.Enums.PlayType = DataType.Enums.PlayType.Single;

    constructor(
        protected _historyService: ILobbyHistoryService,
        chunkSize: number = DataQuery.DEFAULT_CHUNK_SIZE,
    ) {
        super(_historyService, chunkSize);
    }

    public get currentRecordType() {
        return this._currentRecordType;
    }

    public updateGameType(gameType: DataType.Enums.PlayType) {
        if (this._currentRecordType === gameType) {
            return;
        }
        this.resetNoMoreData();
        this._currentRecordType = gameType;
        this.switchToNewQuery();
        this.emit(LobbyHistoryModel.EVENT_TYPE.GAME_TYPE_CHANGED);
    }

    protected getQuery() {
        let query: DataQuery<IHistoryData> = this._machineQueryMap[this.currentRecordType];
        if (!query) {
            query = new DataQuery<HistoryData>({
                query: (page, pageSize) =>
                    this._historyService.getHistoryData(page, pageSize, this._queryStartTime, this._queryEndTime, this._currentRecordType),
                getDataIndex: (data) => data.timestamp,
                isSameData: (data1, data2) => data1.transactionID === data2.transactionID && data1.roundID === data2.roundID,
                sortOrder: SortOrder.Descending,
                chunkSize: this.chunkSize,
            });
            this._machineQueryMap[this.currentRecordType] = query;
        }
        return query;
    }
}
